import { AuditModel } from "./auditModel";
import { Address } from "./contacts";
import { PersonalDetails } from "./contacts";
import { ExternalEntityDetail } from "./entity-detail";

export class Beneficiary extends ExternalEntityDetail{
    public beneficiaryId:number;
    public noOfbeneficiaries:number;
    public beneficiaryName:string;
    public beneficiaryType:any;
    public childEntityId :any
    public percentageofunits:string
    public title: string
    public middleName :string
    public surname:string
    public dateOfBirth;
    public gender: string
    public personalDetails: PersonalDetails[] = [];
    public created_At: Date;
    public updated_By: string;
    public updated_At: any;
    public deleted_By: string;
    public deleted_At: Date;
    public isDeleted: boolean;
    public address=new Address();
    public firstName: string;
    public homePhone: string;
    public mobileNumber: string;
    public workPhone: string;
    email
}

export class BankDetail extends AuditModel {
  public bankId: number
  public entityId: number
  public clientId: number
  public accountingFirmId: number
  public bankName: string
  public accountName: string
  public accountBSB: string
  public accountNumber: string
  public address=new Address()
}

export class Quote extends AuditModel {
  public quoteId: any = 0;
  public jobId: any = 0;
  public clientId: any = 0;
  public quoteNo: any = '';
  public billingMethod: any;
  public total: any;
  public isPublished: any = false;
  public isDraft: any = false;
  public jsonNarrationsStr: any = '';
  public jsonQuoteUserStr: any = '';
}

export class InvoiceBilling extends AuditModel {
  public invoiceId: number
  public invoiceRefNo: string
  public address: string
  public billingMethod: boolean
  public clientId: number
  public clientName: string
  public clientCode: string
  public bPayReference: string
  public estimatedHours: number
  public financialYear: string
  public invoiceNo: string
  public invoicestatus: string
  public jobCode: string
  public jobFee: number
  public jobId: number
  public jobName: string
  public jobNumber: string
  public invoiceDate: any
  public invoiceDueDate: any
  public invoiceType: string
  public billableType: string
  public narrations: any;
  public paymentAdjustment: any;
  public totalPayable: any = 0;
  public invoicesummary: any;
  public _lstdisbinvoice: any;
  public totalQuote: number = 0;
  public subTotal: number = 0;
  public status: any;
  public preparer: string;
  public preparerName: string;
  public reviewerIds: string;
  public reviewerNames: string;
  public approverIds: string;
  public approverNames: string;
  public approvalStatus: string;
  public isInApprovalFlow: boolean;
  public isSent: boolean;
  public templateId: number;
  public wipUntilDate: any;
  public debtorClientId: number;
  public mailingName: string;
  public preferredName: string | null;
  public salutation: string | null;
}

export class History extends AuditModel {
  public id: number
  public jobId: number
  public invoiceNo: string
  public note: string
  public type: string
  public createdAt: string
  public createdBy: string
}

export class Comment extends AuditModel {
  public commentId: number = 0
  public clientId: number = 0
  public jobId: number
  public invoiceNo: string
  public comment: string
  public createdAt: string
  public createdBy: string
  public taggedUsers: string
  public shortName: string
  public textColor: string
  public backgroundColor: string
  public invoiceId: number = 0
}

export class FirmGSTDetail {
  public invoiceDueDate: any;
  public gstSubTotal: any;
  public dueDays: number = 0;
}

export class NarrationDetails {
  public narration: string
  public narrationAmountt: number
  public narrationId: number
}

export class Payment extends AuditModel {
  public paymentId: number = 0
  public invoiceId: number
  public jobId: number
  public invoiceNo: string
  public paymentDate: Date
  public referenceNo: string
  public amountPaid: number
  public paymentMethod: string
  public notes: string
  public invoiceDate: Date
  public totalPayable: number
  public balance: number
  public dueDate: Date
  public invoiceType: string
  public amountInvoiced: number
  public files: any
}

export interface TaxType {
  taxTypeId: number;
  taxName: string;
  taxRate: number;
  effectiveFrom: Date;
  effectiveTo: Date;
  isActive: boolean;
  isDefault: boolean;
}
